<template>
    <div :class="['content-container', 'ipad', { 'desktop': !this.isIpad }]">

        <NavBar :title="setTitle"></NavBar>



        <!-- Content -->
         
        <div class="container pt-sm timeline-container">

            <!-- Tabs -->

        
                 
             
            <ul class="nav nav-pills" role="tablist">
                <li class="nav-item card-logo">
                    <img :src="setImagePath(trial.field_trial_logo[0].url)" class="">
                </li>
                <li class="nav-item">
                    <a @click="trial_analytics('Trial Overview', setTitle, null, $event)" class="nav-link active"
                        id="trial-overview-tab" data-toggle="tab" href="#trial-overview" role="tab"
                        aria-controls="trial-overview" aria-selected="true">Trial Overview</a>
                </li>
                <li class="nav-item">
                    <a @click="trial_analytics('Trial Design', setTitle, null, $event)" class="nav-link"
                        id="trial-design-tab" data-toggle="tab" href="#trial-design" role="tab" aria-controls="trial-design"
                        aria-selected="false">Trial Design</a>
                </li>

                <li class="nav-item has-modal" v-if="hasNonZeroLength(trial.field_inclusion)">
                    <a @click="trial_analytics('Inclusion', setTitle, null, $event)" class="nav-link"
                        id="inclusion-tab" data-toggle="tab" href="#inclusion" role="tab" aria-controls="inclusion"
                        aria-selected="false">+ Inclusion Criteria</a>
                </li>

                <li class="nav-item has-modal" v-if="hasNonZeroLength(trial.field_exclusion)">
                    <a @click="trial_analytics('exclusion', setTitle, null, $event)" class="nav-link"
                        id="exclusion-tab" data-toggle="tab" href="#exclusion" role="tab" aria-controls="exclusion"
                        aria-selected="false">+ Exclusion Criteria</a>
                </li>

                <li class="nav-item has-modal" >
                    <a @click="trial_analytics('endpoints', setTitle, null, $event)" class="nav-link"
                        id="endpoints-tab" data-toggle="tab" href="#endpoints" role="tab" aria-controls="inclusion"
                        aria-selected="false">+ Endpoints</a>
                </li>


                
                <li class="nav-item" v-if="hasNonZeroLength(trial.field_baseline)">
                    <a @click="trial_analytics('Baseline', setTitle, null, $event)" class="nav-link" id="baseline-tab"
                        data-toggle="tab" href="#baseline" role="tab" aria-controls="baseline"
                        aria-selected="false">Baseline</a>
                </li>

                <li class="nav-item" v-if="hasNonZeroLength(trial.field_primary_outcomes)">
                    <a @click="trial_analytics('Primary Outcomes', setTitle, null, $event)" class="nav-link"
                        id="primary-outcomes-tab" data-toggle="tab" href="#primary-outcomes" role="tab"
                        aria-controls="primary-outcomes" aria-selected="false">Primary Outcomes</a>
                </li>

                <li class="nav-item" v-if="hasNonZeroLength(trial.field_efficacy_outcomes)">
                    <a @click="trial_analytics('Efficacy Outcomes', setTitle, null, $event)" class="nav-link"
                        id="efficacy-outcomes-tab" data-toggle="tab" href="#efficacy-outcomes" role="tab"
                        aria-controls="efficacy-outcomes" aria-selected="false">Efficacy Outcomes</a>
                </li>

                <li class="nav-item" v-if="hasNonZeroLength(trial.field_safety_outcomes)">
                    <a @click="trial_analytics('Safety Outcomes', setTitle, null, $event)" class="nav-link"
                        id="safety-outcomes-tab" data-toggle="tab" href="#safety-outcomes" role="tab"
                        aria-controls="safety-outcomes" aria-selected="false">Safety Outcomes</a>
                </li>

                <li class="nav-item" v-if="hasNonZeroLength(trial.field_secondary_outcomes)">
                    <a @click="trial_analytics('Outcomes', setTitle, null, $event)" class="nav-link"
                        id="secondary-outcomes-tab" data-toggle="tab" href="#secondary-outcomes" role="tab"
                        aria-controls="secondary-outcomes" aria-selected="false">Secondary Outcomes</a>
                </li>

                <li class="nav-item" v-if="hasNonZeroLength(trial.field_key_findings)">
                    <a @click="trial_analytics('Key Findings', setTitle, null, $event)" class="nav-link"
                        id="key-findings-tab" data-toggle="tab" href="#key-findings" role="tab" aria-controls="key-findings"
                        aria-selected="false">Key Findings</a>
                </li>

                <li class="nav-item" v-if="hasNonZeroLength(trial.field_pooled_outcomes)">
                    <a @click="trial_analytics('Additional Outcomes', setTitle, null, $event)" class="nav-link"
                        id="pooled-outcomes-tab" data-toggle="tab" href="#pooled-outcomes" role="tab"
                        aria-controls="pooled-outcomes" aria-selected="false">Additional Outcomes</a>
                </li>
            </ul>

          
            <div class="tab-content">
                <!-- Trial Overview -->
                <div class="tab-pane fade show active" id="trial-overview" role="tabpanel"
                    aria-labelledby="trial-overview-tab">
                    <div class="card card-logo-prepend bg-transparent full-width">
                        <img :src="setImagePath(trial.field_trial_logo[0].url)" class="trial_logo">
                        <div class="card-body bg-primary-gradient-top text-white">
                            <p>    <strong>Full Study Name: </strong><span v-html="trial.field_full_study_name[0].value"></span><br />
                                <strong>Objective:</strong>&nbsp;<span v-html="trial.field_trial_overview[0].value"></span>
                            </p>
                        </div>
                        <div class="card-footer bg-primary-gradient-top text-white top_border">
                            <div class="row">
                                <div class="col-6">
                                    <ul class="list-unstyled">
                                        <li><strong>Drug Name:</strong> {{
                                            getTaxonomyData(trial.field_product_list[0].target_id, 'title', 'value') }}
                                        </li>
                                        <li><strong>Pillar:</strong> {{ getDiseaseState(trial.field_pillar_tag, 'name',
                                            'value') }}</li>
                                        <li v-if="hasNonZeroLength(trial.field_disease_state_tag)"><strong>Disease
                                                State:</strong> {{ getDiseaseState(trial.field_disease_state_tag, 'name',
                                                    'value') }}</li>
                                    </ul>
                                </div>
                                <div class="col-6">
                                    <ul class="list-unstyled">
                                        <!-- If a trial completes in the future, show the trial status instead of the date -->
                                        <template
                                            v-if="trialPublished && showStatusIfFutureDate(trial.field_trial_completion_date[0].value)">
                                            <li><strong>Date Published:</strong> {{
                                                trial.field_trial_completion_date[0].value | moment('DD MMMM YYYY') }} </li>
                                        </template>
                                        <template v-else>
                                            <li><strong>Trial Status:</strong> {{ trial.field_status[0].value }} </li>
                                        </template>
                                        <li><strong>Phase:</strong> {{ getPhaseData(trial.field_phase_tag[0].target_id,
                                            'name', 'value') }}</li>
                                        <li><strong>Participants (N):</strong> {{
                                            trial.field_number_of_participants[0].value }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_trial_overview_references)">
                            <h4> <strong>REFERENCES</strong></h4>
                            <p v-html="trial.field_trial_overview_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>
                    </footer>
                    </div>
                  
                </div>



                
                <!-- inclusion creteria -->
                <div class="tab-pane fade" v-if="hasNonZeroLength(trial.field_inclusion)" id="inclusion" role="tabpanel" aria-labelledby="inclusion-tab">
                    <div class="card card-logo-prepend full-width">
                      <div class="card-body full-width">
                        <p v-if="hasNonZeroLength(trial.field_inclusion)"><strong>Inclusion Criteria</strong></p>
                                    <div v-if="hasNonZeroLength(trial.field_inclusion)"
                                        v-html="trial.field_inclusion[0].processed"></div>

                                  
                        </div>
                        <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_trial_design_references)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_trial_design_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>

                    </footer>
                    </div>
                  
                

                    <!-- Inclusion/Exclusion Modal -->


                 

                 
                </div>




                <!-- inclusion creteria -->
                <div class="tab-pane fade" v-if="hasNonZeroLength(trial.field_inclusion)" id="exclusion" role="tabpanel" aria-labelledby="exclusion-tab">
                    <div class="card card-logo-prepend full-width">
                      <div class="card-body full-width">
                       

                                    <p v-if="hasNonZeroLength(trial.field_exclusion)"><strong>Exclusion Criteria</strong></p>
                                    <div v-if="hasNonZeroLength(trial.field_exclusion)"
                                        v-html="trial.field_exclusion[0].processed"></div>
                        </div>
                        <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_trial_design_references)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_trial_design_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>

                    </footer>
                    </div>
                  
                

                    <!-- Inclusion/Exclusion Modal -->


                 

                 
                </div>




                <div class="tab-pane fade" v-if="hasNonZeroLength(trial.field_inclusion)" id="endpoints" role="tabpanel" aria-labelledby="endpoints-tab">
                    <div class="card card-logo-prepend full-width">
                      <div class="card-body full-width">
                        <template v-if="hasNonZeroLength(trial.field_primary_endpoints)">
                                        <p><strong>Primary Endpoints</strong></p>
                                        <div v-html="trial.field_primary_endpoints[0].value"></div>
                                    </template>


                                    <p v-if="hasNonZeroLength(trial.field_primary_efficacy_endpoint_)"><strong>Primary
                                            Efficacy Endpoints</strong></p>
                                    <div v-if="hasNonZeroLength(trial.field_primary_efficacy_endpoint_)"
                                        v-html="trial.field_primary_efficacy_endpoint_[0].value"></div>

                                    <p v-if="hasNonZeroLength(trial.field_primary_safety_endpoint_s_)"><strong>Safety Endpoints</strong></p>
                                    <div v-if="hasNonZeroLength(trial.field_primary_safety_endpoint_s_)"
                                        v-html="trial.field_primary_safety_endpoint_s_[0].processed"></div>

                                    <br v-if="hasNonZeroLength(trial.field_safety_endpoints)" />
                                    <p v-if="hasNonZeroLength(trial.field_safety_endpoints)"><strong>Safety
                                            Endpoints</strong></p>
                                    <div v-if="hasNonZeroLength(trial.field_safety_endpoints)"
                                        v-html="trial.field_safety_endpoints[0].value"></div>
      
                                    <br v-if="hasNonZeroLength(trial.field_secondary_endpoints)" />
                                    <p v-if="hasNonZeroLength(trial.field_secondary_endpoints)"><strong>Secondary
                                            Endpoints</strong></p>
                                    <div v-if="hasNonZeroLength(trial.field_secondary_endpoints)"
                                        v-html="trial.field_secondary_endpoints[0].value"></div>

                                    <p v-if="hasNonZeroLength(trial.field_secondary_efficacy_endpoin)"><strong>Secondary
                                            Efficacy Endpoints</strong></p>
                                    <div v-if="hasNonZeroLength(trial.field_secondary_efficacy_endpoin)"
                                        v-html="trial.field_secondary_efficacy_endpoin[0].processed"></div>

                                    <p v-if="hasNonZeroLength(trial.field_secondary_safety_endpoint_)"><strong>Secondary 
                                            Safety Endpoints</strong></p>
                                    <div v-if="hasNonZeroLength(trial.field_secondary_safety_endpoint_)"
                                        v-html="trial.field_secondary_safety_endpoint_[0].processed"></div>
                        </div>
                        <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_trial_design_references)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_trial_design_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>

                    </footer>
                    </div>
                  
                

                    <!-- Inclusion/Exclusion Modal -->

                 
                </div>


                <!-- endpoints -->

             

                <!-- Trial Design -->

          
                <div class="tab-pane fade" id="trial-design" role="tabpanel" aria-labelledby="trial-design-tab">
                    <div class="card card-logo-prepend full-width">
                      <div class="card-body full-width">

                            <div class="center-img" v-html="trial.field_trial_design[0].processed"></div>

                            <div class="text-center">
                              
                            </div>
                        </div>
                    </div>
                  
                    <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_trial_design_references)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_trial_design_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>

                    </footer>

                    <!-- Inclusion/Exclusion Modal -->


                 

                 
                </div>

                <!-- Baseline -->
                <div v-if="hasNonZeroLength(trial.field_baseline)" class="tab-pane fade" id="baseline" role="tabpanel"
                    aria-labelledby="baseline-tab">
                    <div class="card card-logo-prepend full-width">
                     <div class="card-body">
                            <div class="center-img" v-html="trial.field_baseline[0].processed"></div>
                        </div>

                    </div>
                    <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_baseline_references)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_baseline_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>
                    </footer>
                </div>

                <!-- Primary Outcomes -->
                <div v-if="hasNonZeroLength(trial.field_primary_outcomes)" class="tab-pane fade" id="primary-outcomes"
                    role="tabpanel" aria-labelledby="primary-outcomes-tab">
                    <div class="card card-logo-prepend full-width">
                     <div class="card-body">
                          
                            <div class="center-img" v-html="trial.field_primary_outcomes[0].processed"></div>
                        </div>
                    </div>
                    <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_primary_outcomes_reference)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_primary_outcomes_reference[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>
                    </footer>
                </div>

                <!-- Secondary Outcomes -->
                <div v-if="hasNonZeroLength(trial.field_secondary_outcomes)" class="tab-pane fade" id="secondary-outcomes"
                    role="tabpanel" aria-labelledby="secondary-outcomes-tab">
                    <div class="card card-logo-prepend full-width">
                      <div class="card-body">

                            <div class="center-img" v-html="trial.field_secondary_outcomes[0].processed"></div>
                        </div>
                    </div>
                    <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_secondary_outcomes_referen)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_secondary_outcomes_referen[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>
                    </footer>
                </div>

                <!-- Efficacy Outcomes -->
                <div v-if="hasNonZeroLength(trial.field_efficacy_outcomes)" class="tab-pane fade " id="efficacy-outcomes"
                    role="tabpanel" aria-labelledby="efficacy-outcomes-tab">
                    <div class="card card-logo-prepend full-width">
                       <div class="card-body">

                            <div class="center-img" v-html="trial.field_efficacy_outcomes[0].processed"></div>
                        </div>

                    </div>
                    <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_efficacy_outcomes_referenc)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_efficacy_outcomes_referenc[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>

                    </footer>
                </div>

                <!-- Safety Outcomes -->
                <div v-if="hasNonZeroLength(trial.field_safety_outcomes)" class="tab-pane fade " id="safety-outcomes"
                    role="tabpanel" aria-labelledby="safety-outcomes-tab">
                    <div class="card card-logo-prepend full-width">
                      <div class="card-body">
                            <div class="center-img" v-html="trial.field_safety_outcomes[0].processed"></div>
                        </div>

                    </div>
                    <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_safety_outcomes_references)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_safety_outcomes_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>

                    </footer>
                </div>


                <!-- key findings -->
                <div class="tab-pane fade " id="key-findings" role="tabpanel" aria-labelledby="key-findings-tab"
                    v-if="trial.field_key_findings.length > 0">
                    <div class="card card-logo-prepend full-width">
                       <div class="card-body">
                            <div class="center-img" v-html="trial.field_key_findings[0].processed"></div>
                        </div>

                    </div>
                    <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_key_findings_references)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_key_findings_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>

                    </footer>
                </div>

                <!-- Pooled Outcomes -->
                <div v-if="hasNonZeroLength(trial.field_pooled_outcomes)" class="tab-pane fade" id="pooled-outcomes"
                    role="tabpanel" aria-labelledby="pooled-outcomes-tab">
                    <div class="card card-logo-prepend full-width">
                     <div class="card-body">
                            <div class="center-img" v-html="trial.field_pooled_outcomes[0].processed"></div>
                        </div>
                    </div>
                    <footer class="footer-references">
                        <div v-if="hasNonZeroLength(trial.field_pooled_outcomes_references)">
                            <h4>REFERENCES</h4>
                            <p v-html="trial.field_pooled_outcomes_references[0].processed"></p>
                        </div>
                        <div v-else></div>

                        <div v-if="hasNonZeroLength(trial.field_medbayer_qr_code)">
                            <p class="qr-code" v-html="trial.field_medbayer_qr_code[0].processed"></p>
                        </div>

                    </footer>
                </div>


            </div>
            <ScrollButton />
        </div>

        <div id="menu-overlay"></div>


        <!-- Background Image -->
        <div class="img-bg">
            <img src="img/backgrounds/trials-bg.jpg" class="bottom-left">
        </div>
    </div>
</template> 

<script>

import NavBar from './components/NavBar.vue';
import getTaxonomyData from './components/getTaxonomyData';
import ScrollButton from './components/ui/ScrollButton.vue';

export default {
    extends: getTaxonomyData,
    name: 'TrialsTwo',
    data() {
        return {
            activeTab: 'trial-overview'
        }
    },
    computed: {
        trial() {
            return this.$store.getters.getTrialData
        },
        setTitle() { return this.trial.title[0].value },
        trialPublished() { return this.trial.field_status[0].value == 'Published'; }
    },
    components: {
        NavBar,
        ScrollButton
    },
    watch: {
        // Watch for tab changes
        '$route.hash': {
            handler(newHash) {
                // Remove the # from the hash to get the tab ID
                const tabId = newHash.replace('#', '');
                if (tabId && this.activeTab !== tabId) {
                    this.activeTab = tabId;
                    this.resetScroll();
                }
            },
            immediate: true
        }
    },
    mounted: function () {
        this.trial_analytics('Trial Overview', this.setTitle);
        this.setApprovalCode();

        // Add click listeners to all tab links
        const tabLinks = document.querySelectorAll('.nav-link');
        tabLinks.forEach(link => {
            link.addEventListener('click', () => {
                this.resetScroll();
            });
        });
    },
    methods: {
        resetScroll() {
            // Reset scroll position of the content container
            setTimeout(() => {
                const container = document.querySelector('.tab-content');
                if (container) {
                    container.scrollTop = 0;
                }
                // Also reset the main window scroll if needed
                window.scrollTo(0, 0);
            }, 100); // Small delay to ensure content has rendered
        },
        // Validate array before checking length
        hasNonZeroLength: function (array) {
            return array && array.length > 0;
        },
        showStatusIfFutureDate(d) {
            let m = this.$moment;
            let status = m().isSameOrAfter(d);

            return status;
        },
        trial_analytics: function (name, title, modal = null, event = null) {
            // Reset scroll position of the content container
            this.resetScroll();

            let o = {
                tabName: name,
                trialName: title,
                modal: modal
            }

            this.$emit('log', o);

            if (event) {
                this.trackEvent(name, modal);
            }
        },
        trackEvent: function (name, modal) {
            const type = modal !== null ? 'Modal' : 'Tab';
            this.analytics.trackGoal(
                this.$router.currentRoute.path,
                name + ' ' + type,
                name
            );
        },
        setApprovalCode: function () {
            const approval = this.trial.field_approval_numbers;
            if (approval && approval[0] && approval[0].value.length > 0) {
                let approvalCode = approval[0].value;
                this.$store.dispatch('setApprovalCode', approvalCode);
            }
        }
    },
    beforeMount: function () {
        this.$store.dispatch('clearRowData');
        let routeId = this.$route.params.id;
        this.$store.dispatch('setSpecificRow', routeId);
    },
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('setDefaultApprovalCode');
        next();
    },
    beforeDestroy() {
        // Clean up event listeners
        const tabLinks = document.querySelectorAll('.nav-link');
        tabLinks.forEach(link => {
            link.removeEventListener('click', this.resetScroll);
        });
    }
}


</script>

<style scoped>
.full-width {
    width: 100%;
}

.qr-code {
    position: relative;
    min-height: 70px;
    text-align: right !important;
}

.qr-code img {
    position: absolute;
    top: 0;
    right: 0;
}
</style>

